/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */
function isExpired(initialTime, expiry) {
  var targetTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : +new Date();

  // Always expired if < 0
  if (initialTime === null || expiry === undefined || expiry < 0) {
    return true;
  } // Never expires if == 0


  if (expiry === 0) {
    return false;
  }

  return initialTime + expiry <= targetTime;
}

export { isExpired };